import { Injectable } from '@angular/core';
import { Config, OccConfig } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
  useExisting: Config,
})
export abstract class AsmConfig extends OccConfig {
  asm?: {
    agentSessionTimer?: {
      startingDelayInSeconds?: number;
    };
    customerSearch?: {
      maxResults?: number;
    };
  };
}

declare module '@spartacus/core' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Config extends AsmConfig {}
}
